<template>
  <div class="flex items-center rounded-xl border bg-white px-2">
    <img alt="image" class="h-6" src="@/assets/icons/search.svg" />
    <input
      disabled
      class="flex-1 text-lg bg-transparent px-4 py-2 outline-none"
      placeholder="Search BandB menu"
    />
  </div>
</template>
